module.exports = __webpack_public_path__ + "img/temperature.a2350f2d.svg";